module.exports = __webpack_public_path__ + "img/celebrate.29825e08.gif";